import { baseService } from "service/base";

class NetworkDeviceVersionsService {
  load(networkId) {
    return baseService.get(`/api/network/${networkId}/device_versions`);
  }
}

const networkDeviceVersionsService = new NetworkDeviceVersionsService();

export { networkDeviceVersionsService };
